/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ScheduleIcon = props => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
			<path
				fill='#707070'
				d='M18.8 4.636h-1.55v-.818a.753.753 0 1 0-1.5 0v.818H8.234v-.818A.726.726 0 0 0 7.5 3a.749.749 0 0 0-.766.818v.818H5.2A2.175 2.175 0 0 0 3 7.091v3.874c-.083-.048 18 .329 18 .224v-4.1a2.175 2.175 0 0 0-2.2-2.453Zm.7 4.909-15-.077V7.014c0-.452.2-.889.7-.889h1.534v.966a.749.749 0 0 0 .766.818.726.726 0 0 0 .734-.818v-.966h7.516v.966a.753.753 0 1 0 1.5 0v-.966h1.55c.5 0 .7.514.7.966Z'
				data-name='5edcf0cfffdc52f28f2b175ef4c26e35'
			/>
			<path fill='none' d='M0 0h24v24H0z' data-name='Rect\xE1ngulo 85591' />
			<g fill='#f7f7fb' data-name='5edcf0cfffdc52f28f2b175ef4c26e35'>
				<path d='M18.8 20.25H5.2c-1.262 0-1.45-1.068-1.45-1.705v-8.209c.75-.006 2.305-.013 5.505-.013 4.152 0 9.157.012 10.995.022v8.2c0 .637-.188 1.705-1.45 1.705Z' />
				<path
					fill='#707070'
					d='M9.255 9.573v1.5c-2.398 0-3.862.004-4.755.008v7.464c0 .955.455.955.7.955h13.6c.245 0 .7 0 .7-.955v-7.454c-2.162-.009-6.389-.018-10.245-.018v-1.5m0 0c5.197 0 11.745.018 11.745.03v8.942C21 19.901 20.291 21 18.8 21H5.2C3.709 21 3 19.901 3 18.545V9.603c.033-.022 2.855-.03 6.255-.03Z'
				/>
			</g>
		</svg>
	)
}

export default ScheduleIcon
